module.exports = __webpack_public_path__ + "assets/images/igg2.d544cd2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/return/igg2.png
// module id = 800
// module chunks = 1